export default {
  csosnCollection: [],
};
